import {
    addFinancialExpense,
    addFinancialIndexRate,
    addFinancialInsuranceRate,
    addNewFinancialRate,
    deleteFinancialExpense,
    deleteFinancialIndexRate,
    deleteFinancialInsuranceRate,
    deleteFinancialRate,
    fetchBackofficeFinancials,
    fetchClientTypes,
    editInsuranceData,
    fetchFinancialDetailsById,
    financialTinsOperation,
    getEntityCompanyDropdown,
    getEntityGroupsDropdown,
    getInsuranceData,
    getProductsByFinancialId,
    getSearchByPostalCode,
    getTinsDropdownBy,
    saveFinancial,
    saveFinancialRatesSalesman,
    saveFinancialRatesValue,
    updateInsurancesAvailableByFinancial,
    getFinacialDisclaimer,
    financialDisclaimerOperation,
} from "../../api/backoffice";

import Vue from "vue";
import i18n from "@/i18n";
import {setFieldValueHandler, setSpreadFieldValueHandler, setDisclaimerFieldValueHandler} from "@/store/handlers/financialBackofficeFormHandlers";
import store from "@/store";
import {getFinancialActiveFinancials} from "@/api/simulation";

import {getInstalationsDropdown} from "../../api/authentication";
import { carType } from "@/utils/bkoFormMapper";

const hasInvalidValue = (v) => {
    if (v?.type === "dropdown") {
        let invalidValue = true;
        v.options?.map((option) => {
            if (option.selected) {
                invalidValue = option?.value == null || v.value === "-1" || v.value === "";
            }
        });
        return invalidValue;
    }

    return v.value == null || v.value === "";
};

const getDefaultState = () => {
    return {
        // ******* Backoffice financial details *************
        financialBkoForm: {},
        spreadsForm: {},
        activeTab: {},
        financialDetails: {},
        financialData: {
            expenses: [],
            residualValue: [],
            rewardRates: [],
            indexRates: [],
            ports: [],
            insuranceRates: [],
        },
        apiCredencialsData: {
            credencials: [],
            externalEntityCodes: [],
        },
        disclaimerData: [],
        financialDetailsDropdown: {
            nationalityList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                }, {
                    value: "PT",
                    text: i18n.t("global.country.portugal"),
                }, {
                    value: "ES",
                    text: i18n.t("global.country.spain"),
                }
            ],
            xmlVersionList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                }, {
                    value: "2021",
                    text: "2021",
                }, {
                    value: "2020",
                    text: "2020",
                }
            ],
            entityCompanyList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 0,
                    text: i18n.t("Todas"),
                }
            ],
            entityGroupList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                }
            ],
            entityGroups: [],
            clientTypes: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                }
            ],
            products: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                }
            ],
            vehicleTypesOptions: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: "Novo",
                    text: i18n.t("Novo"),
                },
                {
                    value: "Usado",
                    text: i18n.t("Usado"),
                },
            ],
            clientTypesOptions: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 5,
                    text: "ALL",
                },
                {
                    value: 1,
                    text: "Particular",
                },
                {
                    value: 2,
                    text: "ENI",
                },
                {
                    value: 3,
                    text: "Empresa",
                },
                {
                    value: 4,
                    text: "Autónomo",
                },
            ],
            periodicityOptions: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 12,
                    selected: true,
                    text: i18n.t("Anual"),
                },
                {
                    value: 6,
                    text: i18n.t("Semestral"),
                }
            ],
            brands: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 'ALL',
                    text: i18n.t("ALL"),
                }
            ],
            tins: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                }
            ],
            expensesFinancedOptions: [
                {
                    value: -2,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 1,
                    text: i18n.t("Mandatório"),
                },
                {
                    value: 0,
                    text: i18n.t("Opcional"),
                },
                {
                    value: -1,
                    text: i18n.t("Não Aplicável"),
                },
            ],
            taxFinancedOptions: [
                {
                    value: -2,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 1,
                    text: i18n.t("Mandatório"),
                },
                {
                    value: 0,
                    text: i18n.t("Opcional"),
                },
                {
                    value: -1,
                    text: i18n.t("Não Aplicável"),
                },
            ],
            rateTypesOptions: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: "Fixa",
                    text: i18n.t("Fixa"),
                },
                {
                    value: "Indexada",
                    text: i18n.t("Indexada"),
                }
            ],
            entitiesList: [
                {
                    value: -2,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            wsOriginList: [
                {
                    value: "",
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: "WsSIFASimulServiceCRetail",
                    text: "CRetail Service",
                },
                {
                    value: "WsSIFASimulServiceHyundai",
                    text: "Hyundai Service",
                },
                {
                    value: "WsSIFASimulServiceNissan",
                    text: "Nissan Service",
                },
                {
                    value: "WsSIFASimulServiceHonda",
                    text: "Honda Service",
                    disabled: true,
                },
                {
                    value: "WsSIFASimulServiceBYD",
                    text: "BYD Service",
                    disabled: true,
                },
                {
                    value: "WsSIFASimulServiceXPeng",
                    text: "XPeng Service",
                    disabled: true,
                },
            ]    
        },
        containsChanges: false,
        // ******* Backoffice Financials list *************
        backofficeFinancials: [],
        totalPages: 0,
        totalResults: 0,
        filters: {
            country: "",
            status: "S",
            filter_search: "",
        },
        dropdownsFilters: {
            statusList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: 1,
                text: "Ativo",
                selected: true,
            }, {
                value: 0,
                text: "Inativo",
            }],
            nationalityList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: "PT",
                text: "Portugal",
            }, {
                value: "ES",
                text: "Espanha",
            }],
        },
        isTableLoading: false,
        // ******* Backoffice Spreads *************
        spreadsFilters: {},
        // ******* Backoffice Insurance *************
        insuranceFilters: {
            insurance: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 0,
                    text: "Comissão",
                }
            ],
            comissionType: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 0,
                    text: "Comissão",
                },
                {
                    value: 1,
                    text: "Indexada",
                }
            ]
        },
        insuranceList: {},
        copyObject: null,
        // ******* Backoffice Taxas - Taxa nominal de juros *************
        nominalRatesFilters: {},
        nominalRatesData: {
            tins: {}
        },
        disclaimerForm: {},
        disclaimerDetails: {},
        idFinancial: -1,
        idFinancialInstance: null, 
        idInstance: null, 
        entityGroupsData: [],
    };
};

const state = getDefaultState();

const getters = {
    // ******* Backoffice financial details *************
    getFinancialBkoForm: (state) => state.financialBkoForm,
    getSpreadsForm: (state) => state.spreadsForm,
    getFinancialDetails: (state) => state.financialDetails,
    getFinancialAvailableProducts: (state) => {
        const multiSelectOptions = [];
        const products = state.financialDetails.financialData?.products_available;
        
        if (!Array.isArray(products)) return [];
        
        products.forEach((product) => {
            multiSelectOptions.push({ value: product?.id, text: product?.name });
        });
        return multiSelectOptions;
    },
    getFinancialAvailableUsedProducts: (state) => {
        const multiSelectOptions = [];
        state.financialDetails.financialData?.products_used?.forEach((product) => {
            multiSelectOptions.push({ value: product?.id, text: product?.name });
        });
        return multiSelectOptions;
    },
    getActiveTab: (state) => state.activeTab,
    getNationalityList: (state) => state.financialDetailsDropdown.nationalityList,
    getXMLVersionList: (state) => state.financialDetailsDropdown.xmlVersionList,
    getProducts: (state) => state.financialDetailsDropdown.products,
    getCompanies: (state) => state.financialDetailsDropdown.entityCompanyList,
    getClientTypes: (state) => state.financialDetailsDropdown.clientTypesOptions,
    getPeriodicity: (state) => state.financialDetailsDropdown.periodicityOptions,
    getVehicleTypesOptions: (state) => state.financialDetailsDropdown.vehicleTypesOptions,
    getCarBrands: (state) => state.financialDetailsDropdown.brands,
    getExpensesData: (state) => state.financialData.expenses,
    getIndexRatesData: (state) => state.financialData.indexRates,
    getPortsData: (state) => state.financialData.ports,
    getInsuranceRatesData: (state) => state.financialData.insuranceRates,
    getRateTypesOptions: (state) => state.financialDetailsDropdown.rateTypesOptions,
    getResidualValueData: (state) => state.financialData.residualValue,
    getRewardRatesData: (state) => state.financialData.rewardRates,
    getSearchByPostalCode: (state) => (key) => state.financialDetailsDropdown[`locality-${key}`],
    getFinancialDropdown: (state) => (key) => state.financialDetailsDropdown[key],
    getContainsChanges: (state) => state.containsChanges,
    getFormTabs: (state) => state.financialBkoForm.tabs,
    // ******* Backoffice Financials list *************
    getBackofficeFinancials: (state) => state.backofficeFinancials,
    getFinancialsTotalPages: (state) => state.totalPages,
    getFinancialsTotalResults: (state) => state.totalResults,
    getFinancialsFilledFilters: (state) =>
        Object.fromEntries(
            Object.entries(state.filters).filter(([, v]) => {
                return v != "";
            })
        ),
    getCompaniesFilterByKey: (state) => (key) => state.filters[key],
    getDropdown: (state) => (key) => state.dropdownsFilters[key],
    isTableLoading: (state) => state.isTableLoading,
    // ******* Backoffice Spreads *************
    getSpreadsFilters: (state) => (key) => state.spreadsFilters[key],
    getSpreadData: (state) => state.financialDetails?.spreadData?.rates,
    // ******* Backoffice Insurance *************
    getInsuranceFilters: (state) => (key) => state.insuranceFilters[key],
    getInsurances: (state) => {
        return state.insuranceList;
    },
    getFinancialAvailableInsurances: (state) => {
        const multiSelectOptions = [];
        const insurances = state.financialDetails.insuranceData?.insurances_available;
        for (const insurance in insurances){
            multiSelectOptions.push({ value: insurance, text: insurances[insurance] });
        }
        return multiSelectOptions;
    },
    getFinancialAvailableUsedInsurances: (state) => {
        const multiSelectOptions = [];
        const insurances = state.financialDetails.insuranceData?.insurances_used;
        for (const insurance in insurances){
            multiSelectOptions.push({ value: insurance, text: insurances[insurance].name });
        }
        return multiSelectOptions;
    },
    // ******* Backoffice Taxas - Taxa nominal de juros *************
    getNominalRatesFilters: (state) => (key) => state.nominalRatesFilters[key],
    getRatesSalesmanData: (state) => state.financialDetails?.nominalRatesData?.ratesSalesman,
    getNominalRatesData: (state) => state.financialDetails?.nominalRatesData?.tins,
    getCopyObject: (state) => state.copyObject,
    getOpenRate: (state) => state.financialDetails?.financialData?.openRate,
    getTINsDropdown: (state) => state.financialDetailsDropdown.tins,
    getTinsSalesmanData: (state) => state.financialDetails?.nominalRatesData?.tinsSalesman,
    getExpenseFinancedOptions: (state) => state.financialDetailsDropdown.expensesFinancedOptions,
    getTaxFinancedOptions: (state) => state.financialDetailsDropdown.taxFinancedOptions,
    getCredencialData: (state) => state.apiCredencialsData.credencials,
    getEntitiesList: (state) => state.financialDetailsDropdown.entitiesList,
    getDisclaimerData: (state) => state.disclaimerData,
    getDisclaimerForm: (state) => state.disclaimerForm,
    getWsOriginList: (state) => {
        return state.financialDetailsDropdown.wsOriginList;
    },
    getDisclaimerDetails: (state) => state.disclaimerDetails,
    getIdFinancial: (state) => state.idFinancial,
    getExternalEntityCodesData: (state) => state.apiCredencialsData.externalEntityCodes,
    getEntityGroups: (state) => state.financialDetailsDropdown.entityGroups,
    getIdInstance: (state) => state.idInstance,
    getIdFinancialInstance: (state) => state.idFinancialInstance,
    getEntityGroupsData: (state) => state.entityGroupsData,
};

const mutations = {
    // ******* Backoffice financial details *************
    setFinancialBkoForm(state, financialBkoForm) {
        state.financialBkoForm = financialBkoForm;
    },
    setFieldProductOptions(state, productsAvailable) {
        state.activeTab.form = state.activeTab.form.map((section) => {
            if (section.sectionId === 1) {
                section.fields[0].options = productsAvailable;
            }
            return section;
        });
    },
    setSpreadsForm(state, spreadsForm) {
        state.spreadsForm = spreadsForm;
    },
    setDisclaimerForm(state, disclaimerForm) {
        state.disclaimerForm = disclaimerForm;
    },
    collapseSection(state, sectionId) {
        state.activeTab.form = state.activeTab.form.map((section) => {
            if (section.sectionId === sectionId) section.isCollapsed = !section.isCollapsed;
            return section;
        });
    },
    setFinancialDetails(state, financialDetails) {
        state.financialDetails = financialDetails;
    },
    setDisclaimerDetails(state, disclaimerDetails) {
        state.disclaimerDetails = disclaimerDetails;
    },
    setFinancialDetailsProducts(state, products_available) {
        state.financialDetails.financialData.products_available = products_available;
    },
    resetFinancialDetailsDropdownsState(state) {
        state.financialDetailsDropdown = getDefaultState().financialDetailsDropdown;
    },
    setFinancialExpensesData(state, expensesData) {
        state.financialData.expenses = expensesData?.map((expense, index) => {
            return {
                id: index,
                ...expense,
                dtStart: expense.dtStart || '',
                disabled: true,
                newRow: false,
                productOptions: state.financialDetailsDropdown.products,
                expensesFinancedOptions: state.financialDetailsDropdown.expensesFinancedOptions,
                vehicleTypesOptions: state.financialDetailsDropdown.vehicleTypesOptions,
                companyOptions: state.financialDetailsDropdown.entityCompanyList
            }
        });
    },
    setFinancialIndexRatesData(state, indexRatesData) {
        state.financialData.indexRates = indexRatesData?.map((indexRate, index) => {
            return {
                id: index,
                ...indexRate,
                dtStart: indexRate.dtStart || '',
                disabled: true,
                newRow: false,
                rateTypesOptions: state.financialDetailsDropdown.rateTypesOptions,
                oldRow: indexRate,
            }
        });
    },
    setFinancialPortsData(state, portsData) {
        state.financialData.ports = portsData?.map((port, index) => {
            return {
                id: index,
                idInstance: port.idInstance,
                idProduct: port.ivIdProduct,
                dtStart: port.ivDtStart || '',
                product: state.financialDetailsDropdown.products.find((product) => product.value === port.ivIdProduct)?.text,
                clientType: state.financialDetailsDropdown.clientTypes.find((clientType) => clientType.value === port.ivIdClientType)?.text,
                value: port.ivValue,
                valueForTaeg: port.ivValueForTaeg,
                disabled: true,
                newRow: false,
                productOptions: state.financialDetailsDropdown.products,
                clientTypesOptions: state.financialDetailsDropdown.clientTypes,
                oldRow: port,
            }
        });
    },
    setFinancialInsuranceRatesData(state, insuranceRatesData) {
        let allProducts = getters.getFinancialAvailableProducts(state).concat(getters.getFinancialAvailableUsedProducts(state));
        allProducts.push({
            value: 0,
            text: "Todos",
            disabled: false,
        })
        const products = state.financialDetailsDropdown.products.concat({
            value: 0,
            text: "Todos",
            disabled: false,
        });
        const clientTypes = state.financialDetailsDropdown.clientTypes.concat({
            value: 0,
            text: "Todos",
            disabled: false,
        });
        state.financialData.insuranceRates = insuranceRatesData?.coeficientRates?.map((rate, index) => {
            return {
                id: index,
                dtStart: rate.dtStart || '',
                product: allProducts.find((product) => product.value === rate.idProduct)?.text,
                clientType: clientTypes.find((clientType) => clientType.value === rate.idClientType)?.text,
                ...rate,
                disabled: true,
                newRow: false,
                productOptions: products,
                clientTypesOptions: clientTypes,
            }
        });
    },
    setSpreadData(state, spreadData) {
        state.financialDetails.spreadData.rates = spreadData;
    },
    setNominalRatesData(state, tinsData) {
        const vehicleTypes = state.financialDetailsDropdown.vehicleTypesOptions;
        const companies = state.financialDetailsDropdown.entityCompanyList;
        
        let tins = {};
        const setDatesStart = new Set();
        Object.keys(tinsData[0] || tinsData)?.forEach(vehicleType => {
            tins[vehicleType] = tinsData[vehicleType]?.map((financialTin) => {
                setDatesStart.add(financialTin?.dtStart);
                return {
                    ...financialTin,
                    disabled: true,
                    newRow: false,
                    vehicleTypesOptions: vehicleTypes,
                    companyOptions: companies
                }
            }) || [];
        });
        state.financialDetails.nominalRatesData.tins = tins;

        this.commit("FinancialsBkoFormModule/setNominalRatesFilters", { key: 'dateStartArray', arr: [...setDatesStart].sort((a, b) => new Date(b) - new Date(a)) });
    },
    setRatesSalesmanData(state, ratesSalesman) {
        state.financialDetails.nominalRatesData.ratesSalesman = ratesSalesman;
    },
    setFinancialResidualValue(state, residualValueData) {
        state.financialData.residualValue = residualValueData?.map((rv, index) => {
            return {
                id: index,
                idInstance: rv.idInstance,
                idFinancialInstance: rv.idFinancialInstance,
                idFinancial: rv.ivIdFinancial,
                ivBrand: rv.ivBrand,
                ivIdGroup: state.financialDetailsDropdown.entityGroupList.find((group) => group.value === rv.ivIdGroup)?.text || rv.ivIdGroup,
                ivValue: rv.ivValue,
                ivIdProduct: state.financialDetailsDropdown.products.find((product) => product.value === rv.ivIdProduct)?.text,
                ivIdClientType: state.financialDetailsDropdown.clientTypesOptions.find((clientType) => clientType.value === rv.ivIdClientType)?.text,
                dtStart: rv.dtStart || '',
                disabled: true,
                newRow: false,
                productOptions: state.financialDetailsDropdown.products,
                groupOptions: state.financialDetailsDropdown.entityGroupList,
                brandsOptions: state.financialDetailsDropdown.brands,
                clientTypes: state.financialDetailsDropdown.clientTypesOptions,
            }
        });
    },
    setFinancialRewardsRates(state, rewardsRatesData) {
        state.financialData.rewardRates = rewardsRatesData?.map((rr, index) => {
            return {
                id: index,
                idInstance: rr.idInstance,
                ivIdClientType: state.financialDetailsDropdown.clientTypesOptions.find((clientType) => clientType.value === rr.id_clienttype)?.text,
                ivValue: rr.max_reward,
                disabled: true,
                newRow: false,
                clientTypes: state.financialDetailsDropdown.clientTypesOptions,
            }
        });
    },
    setTinSalemanData(state, tinsSalesman) {
        state.financialDetails.nominalRatesData.tinsSalesman = tinsSalesman;
    },
    setCredencialData(state, { credencialData, tableName = 'credencials' }) {
        
        const tableContent = credencialData?.map((rowData, index) => {
            return {
                apiEntityData: rowData.apiEntityData,
                blocked: rowData.blocked,
                dtCreated: rowData.dtCreated,
                dtCreatedFormat: rowData.dtCreatedFormat,
                dtUpdated: rowData.dtUpdated,
                dtUpdatedFormat: rowData.dtUpdatedFormat,
                idEntity: rowData.idEntity,
                entityName: rowData.entityName,
                isActiveEntity: rowData.activeEntity,
                idFinancial: rowData.idFinancial,
                idUser: rowData.idUser,
                password: rowData.password,
                user: rowData.user,
                entitiesOptions: state.financialDetailsDropdown.entitiesList,
                disabled: true,
                newRow: false,
                id: index
            }
        });

        switch(tableName) {
            case 'externalEntityCodes':
                state.apiCredencialsData.externalEntityCodes = tableContent;
                break;
            default:
                state.apiCredencialsData.credencials = tableContent;
                break;
        }
    },
    setDisclaimerData(state, disclaimerData) {
        state.disclaimerData = disclaimerData?.map((data) => {
            return {
                ...data,
                productName: state.financialDetailsDropdown.products.find((product) => product.value === data.idProduct)?.text,
                vehicleType: carType[data?.carType],
            }
        });
    },
    addRowToTable(state, {newRow, tableName, position = "START"}) {
        
        let tableContent = [];
        switch(tableName) {
            case 'credencials':
                tableContent = state.apiCredencialsData?.[tableName];
                break;
            case 'externalEntityCodes':
                tableContent = state.apiCredencialsData?.[tableName];
                break;
            default:
                tableContent = state.financialData?.[tableName];
                break;
        }

        const maxId = tableContent.reduce((max, row) => {
            return row.id > max ? row.id : max;
        }, 0);
        newRow.id = maxId + 1;

        if (position == 'START') {
            tableContent.unshift(newRow);
        }

        if (position == 'END') {
            tableContent.push(newRow);
        }
    },
    removeFirstRowFromTable(state, {tableName}) {
        switch(tableName) {
            case 'credencials':
                state.apiCredencialsData[tableName].shift();
                break;
            case 'externalEntityCodes':
                state.apiCredencialsData[tableName].shift();
                break;
            default: 
                state.financialData[tableName].shift();
                break;
        }
    },
    removeLastRowFromTable(state, {tableName}) {
        state.financialData[tableName].pop();
    },
    setEntitySimpleList(state, {data, stateType, type}) {
        let dropdownNeoObj = data?.map((item) => {
            return item["NAME"];
        });
        state[stateType][type] = dropdownNeoObj;
    },
    setActiveTab(state, tabId) {
        state.financialBkoForm.tabs = state.financialBkoForm.tabs.map((t) => {
            if (t.id == tabId) {
                t.active = true;
                // set active tab
                state.activeTab = t;
            } else {
                t.active = false;
            }
            return t;
        });
    },
    setNextActiveTab(state) {
        const activeTab = state.financialBkoForm.tabs.find((tab) => tab.active);
        const activeTabIndex = state.financialBkoForm.tabs.indexOf(activeTab);
        //If activeTabIndex is the index of the last tab in the array, 
        //adding 1 would result in an index that is out of bounds. 
        //To handle this, we use the modulo (%) operator to calculate the remainder of dividing (activeTabIndex + 1) by state.form.tabs.length. 
        //This ensures that we "wrap around" to the beginning of the array if we reach the end.
        const nextTabIndex = (activeTabIndex + 1) % state.financialBkoForm.tabs.length;
        const nextTab = state.financialBkoForm.tabs[nextTabIndex];
        this.commit("FinancialsBkoFormModule/setActiveTab", nextTab?.id);
    },
    setFieldValue(state, {key, value, onChangeActions = null, options = []}) {
        console.log(options);
        setFieldValueHandler(state, onChangeActions, value, key);
    },
    setSpreadFieldValue(state, {key, value, changeAction, onChangeActions, options = []}) {
        console.log(options);
        setSpreadFieldValueHandler(state, {key, value, changeAction, onChangeActions, options});
    },
    setDisclaimerFieldValue(state, {key, value, changeAction, onChangeActions, options = []}) {
        console.log(options);
        setDisclaimerFieldValueHandler(state, {key, value, changeAction, onChangeActions, options});
    },
    setIncrementField(state, {key}) {
        state?.activeTab?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field.keyReRender += 1;
            }
        });
    },
    setDisclaimerIncrementField(state, { key }) {
        state.disclaimerForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field.keyReRender += 1;
            }
        });
    },
    setFieldAttribute(state, {key, attribute, value}) {
        state?.activeTab?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);

            if (field) {
                if (!(field.key?.startsWith("cp3") || field.key?.startsWith("cpExt")
                    || field.key?.startsWith("nationality") || field.key?.startsWith("xmlVersion")
                )) {
                    let dropdownNeoObj = value?.map((item) => {
                        return {value: item["id"], text: item["name"]};
                    });

                    dropdownNeoObj = [
                        {
                            value: -1,
                            text: i18n.t("dropdownSelection"),
                            disabled: true,
                        },
                        ...dropdownNeoObj,
                    ];
                    field[attribute] = dropdownNeoObj;
                } else {
                    field[attribute] = value;
                }
            }
        });
    },
    setSpreadFieldAttribute(state, {key, attribute, value}) {
        if (state?.activeTab?.key?.startsWith("spreadsData")) {
            state.activeTab?.form?.forEach((form) => {
                const field = form?.fields?.find((f) => f.key === key);
                if (field) {
                    field[attribute] = value;
                }
            });
        }
    },
    setDisclaimerFieldAttribute(state, {key, attribute, value}) {
        state.disclaimerForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field[attribute] = value;
            }
        });
    },
    setContainsChanges(state, containsChanges) {
        state.containsChanges = containsChanges;
    }
    ,
    // ******* Backoffice Financials list *************
    setBackofficeFinancials(state, backofficeFinancials) {
        backofficeFinancials = backofficeFinancials.filter(finance => finance.id !== 1);
        state.backofficeFinancials = backofficeFinancials;
    },
    setFinancialsTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
    setFinancialsTotalResults(state, totalResults) {
        state.totalResults = totalResults;
    },
    setFinancialsFilters(state, financialsFilters) {
        state.financialsFilters = financialsFilters;
    },
    setMixedDropdownValues(state, {data, stateType = "dropdownsFilters", type, valueKey = "ID",}) {
        let dropdownNeoObj = data.map((item) => {
            return {
                value: item?.[valueKey],
                text: item?.NAME,
            };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setPostalCodeFormatDropdown(state, {data, stateType = "financialDetailsDropdown", localityType,}) {
        let dropdownNeoObj = data?.locality?.map((item) => {

            return {
                value: item,
                text: item,
            };
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][localityType] = dropdownNeoObj;
    },
    setEntityCompanySimpleList(state, {data, stateType, type}) {
        let dropdownNeoObj = data?.map((item) => {
            if (item["STATUS"] == "N") {
                return {value: item["ID"], text: item["NAME"], disabled: true,};
            } else {
                return {value: item["ID"], text: item["NAME"]};
            }
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            {
                value: 0,
                text: i18n.t("Todas"),
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setEntityGroupSimpleList(state, {data, stateType, type}) {
        if(type === 'entityGroups') {
            state[stateType][type] = data;
        } else {
            let dropdownNeoObj = data?.map((item) => {return {value: item["ID"], text: item["NAME"]};}) || [];
        
            dropdownNeoObj = [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                ...dropdownNeoObj,
            ];
    
            state[stateType][type] = dropdownNeoObj;
        }
    },
    setBrandList(state, {data, stateType, type}) {
        const dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            {
                value: 'ALL',
                text: i18n.t("ALL"),
            }
        ];

        Object.keys(data).forEach((element) => {
            dropdownNeoObj.push({value: element, text: element});
        });

        state[stateType][type] = dropdownNeoObj;
    },
    setFinancialProducts(state, {data, stateType, type}) {
        let dropdownNeoObj = data?.map((item) => {
            return {value: item["ID"], text: item["NAME"]};
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setClientTypes(state, {data, stateType, type}) {
        let dropdownNeoObj = data?.map((item) => {
            return {value: item["ID"], text: item["NAME"]};
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setFilterByKey(state, filter) {
        state.filters[filter.key] = filter.value;
    },
    setFilters(state, filters) {
        state.filters = filters;
    },
    setTableLoading(state, isTableLoading) {
        state.isTableLoading = isTableLoading;
    },
    // ******* Backoffice Spreads *************
    setSpreadsFilters(state, {key, arr}) {
        state.spreadsFilters[key] = arr;
    },
    setNominalRatesFilters(state, {key, arr}) {
        const data = [
            {
                value: '',
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            {
                value: '',
                text: i18n.t("Clear filter"),
                disabled: false,
            },
            ...arr.map(item => ({
                value: item,
                text: item,
            })),
        ];
        state.nominalRatesFilters[key] = data;
    },
    // ******* Backoffice Insurances **********
    setInsurances(state, insuranceData) {
        state.insuranceList = Object.keys(insuranceData).map((key) => {
            return {
                id: key,
                ...insuranceData[key],
                disabled: true,
                newRow: false
            };
        });
    },
    setCopyObject(state, objectToCopy) {
        state.copyObject = objectToCopy;
    },
    setTINsDropdown(state, {data, stateType, type}) {
        let dropdownNeoObj = data?.map((item) => {
            return {value: item["id"], text: item["formtPercentage"]};
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setEntityList(state, { data, stateType, type }) {
        let dropdownNeoObj = data?.map((item) => {
            return {value: item["ID"], text: item["NAME"]};
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    }, 
    setIdFinancial(state, { idFinancial }) {
        state.idFinancial = idFinancial;
    }, 
    setIdFinancialInstance(state, { idFinancialInstance }) {
        state.idFinancialInstance = idFinancialInstance;
    },
    setIdInstance(state, { idInstance }) {
        state.idInstance = idInstance;
    }, 
    setEntityGroupsData(state, { entityGroupsData }) {
        state.entityGroupsData = entityGroupsData;
    },
    setWsOriginList(state, { data, stateType, type  }) {
        let dropdownNeoObj = data?.map((item) => {
            return {value: item["WS_ORIGIN"], text: item["NAME"] + " Service" };
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
};

const actions = {
    // ******* Backoffice financial details *************
    async getFinancialDetails({dispatch, commit}, { idFinancial, idInstance }) {
        try {
            await dispatch("getAllClientTypes");
            await dispatch("getProducts", { financialId: idFinancial, idInstance: idInstance });
            await dispatch("getEntityGroupList");
            const response = await fetchFinancialDetailsById(idFinancial, idInstance);

            const data = response?.data?.data;

            commit("setFinancialDetails", data);
            commit("setFinancialExpensesData", data?.financialData?.initialExpenses || []);
            commit("setFinancialIndexRatesData", data?.financialData?.euribor || []);
            commit("setFinancialResidualValue", data?.financialData?.residualValues || []);
            commit("setFinancialRewardsRates", data?.financialData?.rewardRatesValues || []);
            commit("setFinancialPortsData", data?.financialData?.portsExpenses || []);
            commit("setInsurances", data?.insuranceData?.insurances_used);

            commit("setNominalRatesData", data?.nominalRatesData?.tins);

            commit("setSpreadData", data?.spreadData?.rates || {});

            commit("setCredencialData", { credencialData: data?.apiCredenciaisData?.credentials, tableName: 'credencials' });
            commit("setCredencialData", { credencialData: data?.apiCredenciaisData?.externalEntityCodes, tableName: 'externalEntityCodes' });

            commit("setDisclaimerData", data?.disclaimerData?.disclaimers || []);

            commit("setIdFinancial", { idFinancial: data?.generalData?.id });

            //commit("setIdFinancialInstance", { idFinancial: data?.generalData?.id });
            //commit("setIdInstance", { idFinancial: data?.generalData?.id });

            commit("FinancialsBkoFormModule/setCopyObject", null, {root: true,});
            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async getSearchByPostalCode({commit}, {localityFieldKey, postalCode, formNationality}) {
        try {
            const response = await getSearchByPostalCode({postalCode, formNationality});

            commit("setPostalCodeFormatDropdown", {
                data: response?.data?.data,
                localityType: "locality-" + localityFieldKey,
                stateType: "financialDetailsDropdown",
            });

            return {
                districtValue: response?.data?.data?.district,
                municipalityValue: response?.data?.data?.municipality
            };

        } catch (error) {
            console.log(error);
        }
    },
    async checkIfFormIsValid({commit}) {
        Vue.$toast.clear();
        commit("setTableLoading", false);
        const fieldsWithError = [];
        let outOfContextErrors = [];

        state?.activeTab?.form?.map((sections) => sections?.fields.map((field) => {
            // se o field estiver activo e for required, validar valor
            // se o field tiver visivel
            if (!field.disabled && !field.hidden && field.required && field.editable && field.fieldShow) {
                const validation = hasInvalidValue(field);
                field.hasError = validation;
                if (validation) fieldsWithError.push(field.label);
            }

            if (field?.key === 'api' && field?.value == 1) {
                const ftpField = sections?.fields.find((field) => field?.key?.startsWith("ftp"));
                const emailAlertNewProposalField = sections?.fields.find((field) => field?.key?.startsWith("emailAlertNewProposal"));
                const emailWithDocumentationField = sections?.fields.find((field) => field?.key?.startsWith("emailWithDocumentation"));
                const emailWithXMLField = sections?.fields.find((field) => field?.key?.startsWith("emailWithXML"));

                let errorMessage = "";
                if (ftpField?.value == 1 || emailAlertNewProposalField?.value == 1 || emailWithDocumentationField?.value == 1 || emailWithXMLField?.value == 1) {
                    errorMessage = i18n.t("pages.FinancialsPage.financialForm.generalData.sendingInformation.apiValidation");
                    outOfContextErrors.push(errorMessage);

                    ftpField.hasError = ftpField?.value == 1;
                    emailAlertNewProposalField.hasError = emailAlertNewProposalField?.value == 1;
                    emailWithDocumentationField.hasError = emailWithDocumentationField?.value == 1;
                    emailWithXMLField.hasError = emailWithXMLField?.value == 1;
                }
            }

            outOfContextErrors = Array.from(new Set(outOfContextErrors));
        }));

        let errorMessage = "<ul>";

        if (fieldsWithError.length || outOfContextErrors.length) {

            fieldsWithError.forEach((label) => {
                errorMessage += `<li>${i18n.t("form.error.requiredFieldWithNoValue", {field: i18n.t(label)})}</li>`;
            });

            outOfContextErrors.forEach((label) => {
                errorMessage += `<li>${i18n.t(label)}</li>`;
            });

            errorMessage += "</ul>";

            Vue.$toast.open({
                message: errorMessage,
                dismissible: true,
                type: "error",
            });

            return false;
        } else {
            return true;
        }
    },
    async checkIfSpreadFormIsValid({commit}) {
        Vue.$toast.clear();
        commit("setTableLoading", false);
        const fieldsWithError = [];
        let outOfContextErrors = [];

        state.spreadsForm.form.map((sections) => sections?.fields.map((field) => {
            // se o field estiver activo e for required, validar valor
            // se o field tiver visivel
            if (!field.disabled && !field.hidden && field.required && field.editable && field.fieldShow) {
                const validation = hasInvalidValue(field);
                field.hasError = validation;
                if (validation) fieldsWithError.push(field.label);
            }

            outOfContextErrors = Array.from(new Set(outOfContextErrors));
        }));

        let errorMessage = "<ul>";

        if (fieldsWithError.length || outOfContextErrors.length) {

            fieldsWithError.forEach((label) => {
                errorMessage += `<li>${i18n.t("form.error.requiredFieldWithNoValue", {field: i18n.t(label)})}</li>`;
            });

            outOfContextErrors.forEach((label) => {
                errorMessage += `<li>${i18n.t(label)}</li>`;
            });

            errorMessage += "</ul>";

            Vue.$toast.open({
                message: errorMessage,
                dismissible: true,
                type: "error",
            });

            return false;
        } else {
            return true;
        }
    },
    async checkIfDisclaimerFormIsValid({commit}) {
        Vue.$toast.clear();
        commit("setTableLoading", false);
        const fieldsWithError = [];
        let outOfContextErrors = [];

        state.disclaimerForm.form.map((sections) => sections?.fields.map((field) => {
            // se o field estiver activo e for required, validar valor
            // se o field tiver visivel
            if (!field.disabled && !field.hidden && field.required && field.editable && field.fieldShow) {
                const validation = hasInvalidValue(field);
                field.hasError = validation;
                if (validation) fieldsWithError.push(field.label);
            }

            outOfContextErrors = Array.from(new Set(outOfContextErrors));
        }));

        let errorMessage = "<ul>";

        if (fieldsWithError.length || outOfContextErrors.length) {

            fieldsWithError.forEach((label) => {
                errorMessage += `<li>${i18n.t("form.error.requiredFieldWithNoValue", {field: i18n.t(label)})}</li>`;
            });

            outOfContextErrors.forEach((label) => {
                errorMessage += `<li>${i18n.t(label)}</li>`;
            });

            errorMessage += "</ul>";
            
            Vue.$toast.open({
                message: errorMessage,
                dismissible: true,
                type: "error",
            });

            return false;
        } else {
            return true;
        }
    },
    async saveFinancial({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const dataType = payload?.dataType;
            const response = await saveFinancial(dataType, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async addNewFinancialRate({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await addNewFinancialRate(payload.idFinancial, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async saveFinancialRatesValue({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await saveFinancialRatesValue(payload.idFinancial, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async deleteFinancialRate({commit}, {idFinancial, idFinancialRate, idInstance}) {
        commit("setTableLoading", false);
        try {
            const response = await deleteFinancialRate(idFinancial, idFinancialRate, idInstance);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    // ******* Backoffice Financials list *************
    async getBackofficeFinancials({ commit, rootGetters }, page) {
        commit("setTableLoading", true);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchBackofficeFinancials(
                page.page,
                page.orderBy,
                page?.search,
                page?.pageSize,
                idInstance
            );
            commit("setBackofficeFinancials", response?.data?.data);
            commit("setFinancialsTotalPages", response?.data?.pages);
            commit("setFinancialsTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async inactivateFinance({commit}, {financialId, instanceId, financialInstanceId }) {
        commit("setTableLoading", false);
        console.log(financialId, instanceId, financialInstanceId);
        try {
            const response = []//await inactivateEntityCompanyById(companyId);
            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async addFinancialExpense({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await addFinancialExpense(payload.idFinancial, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async deleteFinancialExpense({commit}, payload) {
        commit("setTableLoading", false);
        try {
            let queryParams = "?idFinancial=" + payload.idFinancial;
            for (const key in payload) {
                if (key == 'idFinancial') continue;
                queryParams += `&${key}=${payload[key]}`;
            }

            const response = await deleteFinancialExpense(payload.idFinancial, queryParams);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async addFinancialIndexRate({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await addFinancialIndexRate(payload.idFinancial, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async deleteFinancialIndexRate({commit}, payload) {
        commit("setTableLoading", false);
        try {
            let queryParams = "?idFinancial=" + payload.idFinancial;
            for (const key in payload) {
                if (key == 'idFinancial') continue;
                queryParams += `&${key}=${payload[key]}`;
            }

            const response = await deleteFinancialIndexRate(payload.idFinancial, queryParams);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async addFinancialInsuranceRate({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await addFinancialInsuranceRate(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async deleteFinancialInsuranceRate({commit}, payload) {
        commit("setTableLoading", false);
        try {
            let queryParams = "?id=" + payload;

            return await deleteFinancialInsuranceRate(queryParams);
        } catch (error) {
            console.log(error)
        }
    },
    async getProducts({commit}, { financialId, idInstance }) {
        try {
            const response = await getProductsByFinancialId(financialId, idInstance);
            //commit("setProducts", response?.data?.data);
            commit("setFinancialProducts", {
                data: response?.data?.data,
                stateType: "financialDetailsDropdown",
                type: "products",
            })
            return state.financialDetailsDropdown.products;
        } catch (error) {
            console.log(error)
        }
    },
    async getAllClientTypes({commit}) {
        try {
            const responseClientType = await fetchClientTypes();

            commit("setClientTypes", {
                data: responseClientType?.data?.data,
                stateType: "financialDetailsDropdown",
                type: "clientTypes",
            });

            return responseClientType?.data?.data
        } catch (error) {
            console.log(error);
        }
    },
    async getEntityCompanyList({commit, rootGetters}, country = "ALL") {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getEntityCompanyDropdown(idInstance);
            let entityCompany = response?.data?.data;
            if (country != "ALL") {
                entityCompany = entityCompany?.filter((company) => company.COUNTRY === country)
            }

            commit("setEntityCompanySimpleList", {
                data: entityCompany,
                stateType: "financialDetailsDropdown",
                type: "entityCompanyList",
            });
            return entityCompany;
        } catch (error) {
            console.log(error)
        }
    },
    async getBrands({commit}, eurotaxBrandData) {
        const vehicleCategory = 'Ligeiro de Passageiros';
        const eurotax = eurotaxBrandData[vehicleCategory];

        commit("setBrandList", {
            data: eurotax,
            stateType: "financialDetailsDropdown",
            type: "brands",
        });
    },
    async getInsuranceData({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await getInsuranceData(payload);
            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async editInsuranceData({commit}, payload) {
        commit("setTableLoading", false);
        try {
            const response = await editInsuranceData(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async fetchFinancialActiveFinancials({commit}) {
        commit("setTableLoading", false);
        try {
            const response = await getFinancialActiveFinancials();
            return response?.data?.data;
        } catch (error) {
            console.log(error);
        }
    },
    async getEntityGroupList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getEntityGroupsDropdown(idInstance);
            const entityGroups = response?.data?.data || [];

            commit("setEntityGroupSimpleList", {
                data: entityGroups,
                stateType: "financialDetailsDropdown",
                type: "entityGroupList",
            });

            commit("setEntityGroupSimpleList", {
                data: entityGroups,
                stateType: "financialDetailsDropdown",
                type: "entityGroups",
            });

            if(idInstance && !(idInstance === 1 || idInstance === 2)) {
                const entityGroupsList = entityGroups?.filter(group => group.ID != 14) || [];
                commit("setEntityGroupsData", { entityGroupsData: entityGroupsList });
                commit("setWsOriginList", { data: entityGroupsList, stateType: "financialDetailsDropdown", type: "wsOriginList" });
            }
        } catch (error) {
            console.log(error)
        }
    },
    async saveFinancialRatesSalesman({commit}, { idFinancial, operation, payload }) {
        commit("setTableLoading", false);
        try {
            const response = await saveFinancialRatesSalesman(idFinancial, operation, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async financialTinsOperation({commit}, { operation, payload }) {
        commit("setTableLoading", false);
        try {
            const response = await financialTinsOperation(payload.idFinancial, operation, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async getTINsDropdown({ commit, rootGetters }, financialId) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getTinsDropdownBy(financialId, idInstance);
            commit("setTINsDropdown", {
                data: response?.data?.data,
                stateType: "financialDetailsDropdown",
                type: "tins",
            })
            return state.financialDetailsDropdown.tins;
        } catch (error) {
            console.log(error)
        }
    },
    async updateInsurances({commit}, {insurances, financialId, idInstance}) {
        const payload = {
            selInsurances: insurances.map((insurance) => String(insurance.value)),
            idFinancial: financialId,
            idInstance: idInstance
        }
    
        commit("SpinnerModule/setLoading", true, {root: true});
        await updateInsurancesAvailableByFinancial(payload);
        commit("SpinnerModule/setLoading", false, {root: true});
    
    },
    async getEntitiesList({ commit }) {
        try {
            const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getInstalationsDropdown(idInstance);
            const entities = response?.data?.data;
            
            commit("setEntityList", {
                data: entities,
                stateType: "financialDetailsDropdown",
                type: "entitiesList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getDisclaimerDetails({dispatch, commit}, { idFinancial, idInstance, idDisclaimer }) {

        try {
            await dispatch("getProducts", { financialId: idFinancial, idInstance: idInstance });
            const response = await getFinacialDisclaimer(idFinancial, idInstance, idDisclaimer);

            const data = response?.data?.data;
            commit("setDisclaimerDetails", data);

            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async financialDisclaimerOperation({commit}, { operation, payload }) {
        commit("setTableLoading", false);
        try {
            const response = await financialDisclaimerOperation(payload.idFinancial, operation, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
